module.exports = __webpack_public_path__ + "assets/ic-youtube.353af1a5.svg";